"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloaderFromCDN = void 0;
var DownloaderFromCDN = /** @class */ (function () {
    function DownloaderFromCDN(baseURL) {
        this.baseURL = baseURL;
    }
    DownloaderFromCDN.prototype.downloadFiles = function (modelId, version) {
        var _this = this;
        // Download catalog
        return fetch(this.baseURL + "/catalog_" + modelId + "_" + version + ".json").then(function (response) {
            if (response.ok) {
                return response.text();
            }
            else {
                throw new Error("CDN download response status: " + response.status);
            }
        }).then(function (catalog) {
            var catalogInfo = JSON.parse(catalog);
            // URL add-on to resources
            var middleURL = catalogInfo.MajorVersion + "." + catalogInfo.MinorVersion + "/ModelResources";
            var modelInfo = modelId + "/" + version + "/";
            // Download each file from folder
            return Promise.all(catalogInfo.Resources.map(function (catalogElement) {
                if (catalogElement.Name.length > modelInfo.length && catalogElement.Name.substring(0, modelInfo.length) === modelInfo) {
                    catalogElement.Name = catalogElement.Name.substring(modelInfo.length);
                }
                return fetch(_this.baseURL + "/" + middleURL + "/" + catalogElement.Name + "." + catalogElement.Type).then(function (file) {
                    return file.blob();
                }).then(function (blobFile) {
                    return [catalogElement.Name + "." + catalogElement.Type, blobFile];
                });
            }));
        }).then(function (arr) {
            return new Map(arr);
        });
    };
    return DownloaderFromCDN;
}());
exports.DownloaderFromCDN = DownloaderFromCDN;
//# sourceMappingURL=cdn-downloader.js.map